import { DateTime, getLocaleDateString, IDateFormat } from '@agilepoint/utils-date-time';
import { emailRegExp } from './regular-expressions';

export const validateEmail = (email: string) => emailRegExp.test(email);

export function setCookie(cookieName: string, cookieValue: string, expireDays: number, keepMeSignedIn: boolean) {
    const date = new Date();
    // here days are converted to milliseconds
    date.setTime(date.getTime() + (expireDays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + date.toUTCString();
    const cookieExpireValue = keepMeSignedIn ? expires : '';
    const encodedCookieValue = encodeURI(cookieValue);
    document.cookie = cookieName + '=' + encodedCookieValue + ';' + cookieExpireValue + ';path=/';
}

export function getCookie(cookieName: string) {
    const name = cookieName + '=';
    const cookieList = document.cookie.split(';');
    for (let i = 0; i < cookieList.length; i++) {
        let cookie = cookieList[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            const decodedCookieValue = decodeURI(cookie.substring(name.length, cookie.length) || '');
            return decodedCookieValue;
        }
    }
    return '';
}

export function isCookieSupported() {
    return typeof document === 'object' && typeof document.cookie === 'string';
}

export function clearCookies() {
    const cookiesList = document.cookie.split(';');
    for (let i = 0; i < cookiesList.length; i++) {
        const cookie = cookiesList[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + '=;Path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    }
}


export const getFormattedTime = (date: string) => DateTime.fromISO(date).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

export const getFormattedDateTime = (date: string, format?: IDateFormat) => `${getLocaleDateString(new Date(Number(date)), (format || 'MM/dd/yyyy'))} ${getFormattedTime(date)}`;

export const toBoolean = (value: any) => {
    switch (value) {
        case true:
        case 'true':
        case 1:
        case '1':
        case 'on':
        case 'yes':
            return true;
        default:
            return false;
    }
};
